/* eslint-disable react/react-in-jsx-scope */
import { Badge, Grid, makeStyles } from "@material-ui/core";
import useText from "constants/text";
import { IProductPick, InationalTransportPoint, ItemAtPoint } from "contexts/RequestQuoteContext";
import { useState } from "react";
import DialogCatalog from "./Catalog/DialogCatalog";
import { usePickupOrDeliverStyles } from "./styles";

const useStyles = makeStyles({
  badge: {
    left: "23%",
  },
});

interface IArticlesToDeliveryAtPoint {
  articlesToDeliver: ItemAtPoint[];
  possibleArticlesToDeliver: IProductPick[];
  productsChecked: ItemAtPoint[];
  positionPoint: number;
  onChange: (articlesDeliver: ItemAtPoint[]) => void;
  point: InationalTransportPoint;
  productsAlreadyDelivered: ItemAtPoint[];
}
export default function ArticlesToDeliveryAtPoint({
  articlesToDeliver,
  possibleArticlesToDeliver,
  productsChecked,
  positionPoint,
  onChange,
  point,
  productsAlreadyDelivered,
}: IArticlesToDeliveryAtPoint) {
  const [openDialog, setOpenDialog] = useState(false);
  const { text } = useText();
  const styles = useStyles();
  const [changeColor, setChangeColor] = useState(false);
  const classes = usePickupOrDeliverStyles();

  const onValidateFromCatalog = (itemsAtPoint: ItemAtPoint[]) => {
    onChange(itemsAtPoint);
    setOpenDialog(false);
  };

  const getArticlesCount = (articlesToDeliver: ItemAtPoint[]) =>
    articlesToDeliver.reduce((prev, current) => prev + current.counter, 0);

  return (
    <>
      <Grid
        xs={6}
        onClick={() => setOpenDialog(true)}
        style={{ marginTop: "-47px", marginLeft: "52%" }}
        className={changeColor || articlesToDeliver?.length > 0 ? classes.thereAreValues : classes.thereAreNotValue}
      >
        {text.catalog.select_article_to_delivery}
        {Boolean(articlesToDeliver?.length) && (
          <Badge badgeContent={getArticlesCount(articlesToDeliver)} color="primary" className={styles.badge} />
        )}
      </Grid>
      {openDialog && (
        <DialogCatalog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          onValidate={onValidateFromCatalog}
          productsChecked={articlesToDeliver}
          products={possibleArticlesToDeliver || []}
          isForDelivery
          productsToPick={productsChecked}
          positionPoint={positionPoint}
          point={point}
          productsDelivered={productsAlreadyDelivered}
        />
      )}
    </>
  );
}
